<script setup lang="ts">
import { computed, ref, watch } from 'vue'

import { debounce } from '@shared/utils'
import { useCryptoWalletsQuery } from '../api/queries/useCryptoWalletsQuery'
import CryptoWalletsList from '../components/CryptoWalletsList.vue'

import Box from '@uiKit/elements/Box.vue'

const searchQuery = ref('')
const debouncedSearch = ref('')
const currentPage = ref(1)
const rowsPerPage = ref(10)

const updateDebouncedSearch = debounce((value: string) => {
  debouncedSearch.value = value
}, 400)

watch(searchQuery, (value) => updateDebouncedSearch(value))

const filters = computed(() => ({
  page: currentPage.value,
  limit: rowsPerPage.value,
  search: debouncedSearch.value || undefined,
}))

const { data, isLoading } = useCryptoWalletsQuery(filters)
</script>

<template>
  <Box flex direction="col" gap="4">
    <CryptoWalletsList
      :rows="data?.rows ?? []"
      :loading="isLoading"
      :total="data?.rowsCount ?? 0"
      :page="currentPage"
      :page-size="rowsPerPage"
      :search="searchQuery"
      @update:search="searchQuery = $event"
      @update:page="currentPage = $event"
    />
  </Box>
</template>
